import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=c7ddf8c2&"
import script from "./NotFound.ts?vue&type=script&lang=ts&"
export * from "./NotFound.ts?vue&type=script&lang=ts&"
import style0 from "./NotFound.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
